import "./new.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useState } from "react";
import newRequest from "../../context/newRequest";
import {useNavigate} from "react-router-dom";
import {sleep} from "../../services/help";

const New = ({ inputs, title }) => {
  const [file,
    // setFile
  ] = useState("");
  const [info, setInfo] = useState({});
  const [sending, setSending] = useState("");
  const [regionId, setRegionId] = useState(["JABODETABEK"]);
  const navigate = useNavigate();
  const user = localStorage.getItem("user");



  const handleSelectRegionID = (e) => {
    const value = Array.from(
        e.target.selectedOptions,
        (option) => option.value
    );
    setRegionId(value[0]);
  };


  const handleChange = (e) => {
    setInfo((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };

  const handleClick = async (e) => {
    e.preventDefault();
    try {
      setSending("On Submit")
      const newUsers = {
        ...info,
        region_id : regionId,
      };
      await sleep(1000)
      setSending("Mengirim Submit")
      const res= await newRequest.post("/users", newUsers, {
        // headers
        headers: {
          'Authorization': `$Bearer ${user.token}`
        },
      } );
      await sleep(500)
      if (res.status == 200) {
        await sleep(1000)
        await setSending("Submit berhasil")
        await sleep(1000)
        navigate(`/users/${info.id}`);
      }
    } catch (err) {
      setSending(err.response.data.errors)
      console.log(err.response.data.data);
    }
  };
  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar/>
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <div className="left">
            <img
                src={
                  file
                      ? URL.createObjectURL(file)
                      : "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg"
                }
                alt=""
            />
          </div>
          <div className="right">
            <form>
              <div className="formInput">
                {inputs.map((input) => (
                    <div className="formInput" key={input.id}>
                      <label>{input.label}</label>
                      <input onChange={handleChange}
                             type={input.type}
                             placeholder={input.placeholder}
                             id={input.id}
                      />
                    </div>
                ))}
                <label className="formInput">Status</label>
                <select id="roleId">
                  <option value="1">Role User</option>
                  <option value="2">Role Admin</option>
                </select>
                <label className="formInput">Region Default: JABODATABEK </label>
                <select id="region_id" onChange={handleSelectRegionID}>
                  <option value="">Pilih Region Id</option>
                  <option value="JABODETABEK">JABODETABEK</option>
                  <option value="Jawa Timur">Jawa Timur</option>
                  <option value="Lampung">Lampung</option>
                  <option value="Bali">Bali</option>
                  <option value="Yogyakarta">Yogyakarta</option>
                  <option value="Banten">Banten</option>
                  <option value="Sulawesi">Sulawesi</option>

                </select>
              </div>

              <button onClick={handleClick}>Send</button>

            </form>
            {sending && <p className="error">{sending}</p>}
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
          </div>
        </div>

      </div>
    </div>
  );
};

export default New;
